import { render, staticRenderFns } from "./BlockTarget.vue?vue&type=template&id=545a08f0&scoped=true"
import script from "./BlockTarget.vue?vue&type=script&lang=js"
export * from "./BlockTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545a08f0",
  null
  
)

export default component.exports